import { render, staticRenderFns } from "./cModalDataClient.vue?vue&type=template&id=30e1a303&scoped=true"
import script from "./cModalDataClient.vue?vue&type=script&lang=js"
export * from "./cModalDataClient.vue?vue&type=script&lang=js"
import style0 from "./cModalDataClient.vue?vue&type=style&index=0&id=30e1a303&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e1a303",
  null
  
)

export default component.exports